import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Button from '../../Button/Button';
import './LandingCTA.css';

gsap.registerPlugin(ScrollTrigger);

const LandingCTA = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (sectionRef.current && containerRef.current) {
      const randomRotation = gsap.utils.random(-3, 3);

      const entranceAnimation = gsap.fromTo(containerRef.current, 
        { yPercent: 10, rotationZ: randomRotation }, 
        { yPercent: 0, rotationZ: 0, ease: "power1.inOut" }
      );

      const entranceTrigger = ScrollTrigger.create({
        trigger: sectionRef.current,
        start: "top bottom",
        end: "center center",
        animation: entranceAnimation,
        scrub: 0.5,
      });

      return () => {
        if (entranceTrigger) entranceTrigger.kill();
      };
    }
  }, []);

  return (
    <section 
      id="pricing" 
      ref={sectionRef}
      className="landing-cta-section"
    >
      <div 
        ref={containerRef}
        className="landing-cta-container"
      >
        <h2 className="landing-cta-title">
          Better Writing <br />
          Faster Translation <br />
          Smooth Workflow
        </h2>
        <div className="cta-actions-row">
          <div className="cta-text-container">
            <p className="landing-cta-subtitle">
              Get all three with Texta
            </p>
            <p className="pricing-amount">$75.00 / month</p>
          </div>
          <Link to="/signup" className="landing-cta-link">
            <Button variant="primary" size="xlarge">
              Start translating now
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LandingCTA; 